import * as api from '@sloyd/api';
import { actions } from '@sloyd/store-base';
import { Intro, prompt, toast } from '@sloyd/ui';
import { delay, fork, put, takeEvery } from 'saga-ts';
import { getBoolean, invokeEvent, l, setBoolean } from 'shared-base';
import { authGuard } from './helpers/guards';

export const saga = {
  id: 'sloyd.testers',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['TESTERS'],
  },
};

type Verb = 'join' | 'intro';

type Action = {
  type: 'TESTERS';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  join: joinTesters,
  intro: showIntro,
};

export function* joinTesters(action: Action) {
  try {
    yield put(actions.appState.patch({ isAdhocRunning: true }));
    const res = yield api.user.patch({ isAlpha: true });

    if (!res || !res.isSuccess) {
      toast.error('Failed to join, please try again');
      throw new Error('Failed to join alpha');
    }

    toast.show('You have joined the alpha program');
    yield delay(2000);

    localStorage.clear();
    document.location = '/';

    yield put(actions.appState.patch({ isAdhocRunning: false }));
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* showIntro() {
  if (getBoolean('introShown')) {
    return;
  }

  yield delay(2000);

  //setBoolean('introShown', true);

  /*yield prompt.custom({
    title: 'Welcome to V2 Alpha',
    component: Intro,
    componentProps: {},
  });*/
}

export function* testers(action: any) {
  const { verb, id } = action;
  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.testers ${verb} on ${id}`);

  yield* authGuard();

  yield* fork(saga, action, testers);
}

export function* root() {
  yield takeEvery('TESTERS', testers);
}
